var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDoor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 0L40.6367 17.7734L79.8945 88.0859H88.6836V0H50.5Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 11.9141V0H12.3164V88.0859H24.0352L50.5 11.9141Z",
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 8.98438L30.8711 88.0859H79.8945V8.98438H50.5Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 8.98438L29.8945 61.9141H50.5V8.98438H21.1055Z",
    fill: "#636363"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2461 20.8985L50.5 16.9185L38.7812 56.4692L50.5 96.02L65.2461 100V20.8985Z",
    fill: "#0F9AF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 8.98438V88.0859L50.5 96.0199V16.9184L21.1055 8.98438Z",
    fill: "#13BDF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.873 61.3965C59.4911 61.3965 60.8027 60.0848 60.8027 58.4668C60.8027 56.8488 59.4911 55.5371 57.873 55.5371C56.255 55.5371 54.9434 56.8488 54.9434 58.4668C54.9434 60.0848 56.255 61.3965 57.873 61.3965Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoor);
export default __webpack_public_path__ + "static/media/icon_door.354a5f6a2673bfef3b9dea144079a46a.svg";
export { ForwardRef as ReactComponent };